import React from "react";
import { Text, View } from "@/styles/reactnative";
import EarningNavBar from "./EarningNavBar";
import TraderDetailDropdowns from "../../TraderDetailDropdowns";

const StatisticEarningHeader = ({
  coinLists,
  selectCoin,
  setSelectCoin,
  dayLists,
  selectByDay,
  setSelectByDay,
}) => {
  return (
    <View style={{ width: "100%" }}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Text
          size={14}
          style={{
            fontWeight: "600",
            marginBottom: 7,
          }}
        >
          Earnings
        </Text>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 10,
          }}
        >
          <Text size={12}>Derivatives Pair</Text>

          <TraderDetailDropdowns
            data={coinLists}
            selected={selectCoin}
            setSelected={setSelectCoin}
          />
          <TraderDetailDropdowns
            data={dayLists}
            selected={selectByDay}
            setSelected={setSelectByDay}
          />
        </View>
      </View>
      <EarningNavBar />
    </View>
  );
};

export default React.memo(StatisticEarningHeader);
